// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-attribute[data-v-6a03ec21]{padding:1rem}.width-20[data-v-6a03ec21]{width:20%}.width-15[data-v-6a03ec21]{width:15%}.width-5[data-v-6a03ec21]{width:5%}.mx-1[data-v-6a03ec21]{margin-left:.1rem!important;margin-right:.1rem!important}", ""]);
// Exports
module.exports = exports;
